import React, { useCallback, useState } from "react";
// import * as ReactDOMClient from "react-dom/client";
import useAuth from "../../hooks/useAuth";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { Wrapper, Status } from "@googlemaps/react-wrapper";
import { createCustomEqual } from "fast-equals";
import { isLatLngLiteral } from "@googlemaps/typescript-guards";
import "./mapComp.css";
import {
  Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle,
  IconButton, Snackbar, TextField, Tooltip, Typography,
} from "@mui/material";
import { renderToString } from "react-dom/server";
import Marker from "./marker";
import GeoCodes from "./geoCodes";
import { calcIcon } from "./svgFiles";
//import AuthContext from "../../context/authProvider";
// import useMapZoom from "../../hooks/useMapZoom";

// ── Google Maps dark style ────────────────────────────────────────────────────
const DARK_MAP_STYLES = [
  { elementType: "geometry",                                                    stylers: [{ color: "#212121" }] },
  { elementType: "labels.icon",                                                 stylers: [{ visibility: "off" }] },
  { elementType: "labels.text.fill",                                            stylers: [{ color: "#757575" }] },
  { elementType: "labels.text.stroke",                                          stylers: [{ color: "#212121" }] },
  { featureType: "administrative",         elementType: "geometry",             stylers: [{ color: "#757575" }] },
  { featureType: "administrative.country", elementType: "labels.text.fill",    stylers: [{ color: "#9e9e9e" }] },
  { featureType: "administrative.locality",elementType: "labels.text.fill",    stylers: [{ color: "#bdbdbd" }] },
  { featureType: "poi",                    elementType: "labels.text.fill",    stylers: [{ color: "#757575" }] },
  { featureType: "poi.park",               elementType: "geometry",            stylers: [{ color: "#181818" }] },
  { featureType: "poi.park",               elementType: "labels.text.fill",    stylers: [{ color: "#616161" }] },
  { featureType: "poi.park",               elementType: "labels.text.stroke",  stylers: [{ color: "#1b1b1b" }] },
  { featureType: "road",                   elementType: "geometry.fill",       stylers: [{ color: "#2c2c2c" }] },
  { featureType: "road",                   elementType: "labels.text.fill",    stylers: [{ color: "#8a8a8a" }] },
  { featureType: "road.arterial",          elementType: "geometry",            stylers: [{ color: "#373737" }] },
  { featureType: "road.highway",           elementType: "geometry",            stylers: [{ color: "#3c3c3c" }] },
  { featureType: "road.highway.controlled_access", elementType: "geometry",   stylers: [{ color: "#4e4e4e" }] },
  { featureType: "road.local",             elementType: "labels.text.fill",    stylers: [{ color: "#616161" }] },
  { featureType: "transit",                elementType: "labels.text.fill",    stylers: [{ color: "#757575" }] },
  { featureType: "water",                  elementType: "geometry",            stylers: [{ color: "#000000" }] },
  { featureType: "water",                  elementType: "labels.text.fill",    stylers: [{ color: "#3d3d3d" }] },
];

var map_control = {
  maxZoom: 18,
  minZoom: 8,
  streetZoom: 16,
  nodataZoom: 6,
  cityZoom: 9, //15:street,10:city
  saCenter: { lat: -27.878608, lng: 25.685198 },
  // mapRegion: { lat: -27.878608, lng: 25.685198 ,latDelta:,lngDelta:}
  saBounds: {
    north: -22.126891,
    south: -34.825889,
    west: 16.456821,
    east: 32.852903,
  },
  purpleIcon: {
    url: "images/marker-icon-blue.png",
    //size: {"w":32,"h":32},// new google.maps.Size(25, 41),
    size: { width: 25, height: 41 },
    anchor: { x: 12, y: 41 },
    //size: new google.maps.Size(32,32),
    // The origin for this image is (0, 0).
    //origin: new google.maps.Point(0, 0),
    // The anchor for this image is the base of the flagpole at (0, 32).
    //anchor: new google.maps.Point(15, 31)
  },
  redIcon: {
    url: "images/marker-icon-red.png",
    size: { width: 25, height: 41 },
    anchor: { x: 12, y: 41 },
  },
  greenIcon: {
    // url: "http://maps.google.com/mapfiles/ms/icons/green-dot.png",
    url: "images/marker-icon-green.png",
    size: { width: 25, height: 41 },
    anchor: { x: 12, y: 41 },
  },
  startIcon: {
    url: "images/circledplay26.png",
    size: { width: 26, height: 26 },
    anchor: { x: 12, y: 13 },
  },
  stopIcon: {
    url: "images/circledstop26.png",
    size: { width: 26, height: 26 },
    anchor: { x: 12, y: 13 },
  },
  headingInd: {
    //cant be used directly in gapi
    url: "images/headingInd26.png",
    size: { width: 26, height: 26 },
    anchor: { x: 13, y: 13 },
  },
  cameraIcon: {
    url: "images/purplecam18.png",
    size: { width: 18, height: 18 },
    anchor: { x: 9, y: 10 },
  },
};

function MapWrapperComp({ handleStreetViewChange, mapLiveView, ...props }) {
  const [streetViewMarker, setStreetViewMarker] = useState({ open: false });
  const { auth, setAuth } = useAuth();
  // const [mapZoom, setMapZoom] = useState(map_control.nodataZoom);
  // let mapZoom = null;
  // const [mapMarkers, setMapMarkers] = React.useState([]);

  // useEffect(() => {
  //   if (props.markers) {
  //     // setMapMarkers([]);
  //     setMapMarkers([...props.markers]);
  //   }
  // }, [props.markers]);

  // const onIdle = (m) => {
  //   // if (m) {
  //   //   console.log("zoom level:", m.getZoom());
  //   // }
  // };

  // const onZoomChanged = useCallback((m) => {
  //   if (m) {
  //     console.log("zoom level:", m.getZoom());
  //     setMapZoom((prevState) => {
  //       return prevState !== m.getZoom() ? m.getZoom() : prevState;
  //     });
  //   }
  // }, []);

  React.useEffect(() => {
    console.log("render mapWrapper liveView",mapLiveView);
  });

  const onStreetViewChanged = useCallback((p) => {
      if (!p.getVisible()) {
        handleStreetViewChange(false);
        setStreetViewMarker({ open: false });
      }
    }, [handleStreetViewChange] );

  const handleMarkerStreetViewClick = useCallback((pos, heading) => {
    console.log("hello handleMarkerStreetViewClick", heading);
    if (isNaN(Number(heading))) {
      heading = 0;
    }
    setStreetViewMarker({ open: true, pos: pos, heading: Number(heading) });
  }, []);

  return (
    // <AuthContext.Provider value={auth}>
    <Wrapper apiKey={"AIzaSyC5l-LO9GctfR2XVRA8uBuz6VSmEE26CdA"} libraries={["drawing", "geometry"]} render={renderMapStatus}>
      <MaptMem
        liveView={mapLiveView}
        center={props.center} // || map_control.saCenter
        hasCenter={props.center && true}  // onZoomChanged={onZoomChanged}
        poiFitPath={props.poiFitPath}
        currentReg={props.currentReg}
        darkMode={props.darkMode}
        onStreetViewChanged={onStreetViewChanged} // onIdle={onIdle}  // onClick={onClick}
        onPoiClick={props.onPoiClick}
        onDrawingModeChange={props.onDrawingModeChange}
        panoramaPosition={
          !props.displayPath && props.streetViewClick === true
            ? props.center
            : props.displayPath && streetViewMarker.open && streetViewMarker.pos
        }
        panoramaHeading={
          !props.displayPath && props.streetViewClick === true
            ? isNaN(Number(props.heading))
              ? 0
              : Number(props.heading)
            : props.displayPath && streetViewMarker.open && streetViewMarker.heading
        }
        panoramaClick={(!props.displayPath && props.streetViewClick) || (props.displayPath && streetViewMarker.open)}
        markers={props.markers}
        poi={props.poi}
        displayPath={props.displayPath}
        searchPath={props.searchPath}
        {...props.searchPathTitle}
        displaySearchPath={props.displaySearchPath}
        logisticsRoutes={props.logisticsRoutes}
        logisticsPoiPolygons={props.logisticsPoiPolygons}
        historyPath={props.historyPath}
        historyTimes={props.historyTimes}
        replayCarMakeModel={props.replayCarMakeModel}
        zoom={props.zoom || map_control.nodataZoom} //|| map_control.nodataZoom
        maxZoom={map_control.maxZoom}
        minZoom={map_control.nodataZoom}
        style={{
          flexGrow: "1",
          height: "100%",
        }}
        // panoramaInfo={
        //   !props.displayPath && props.streetViewClick === true
        //     ? {
        //         position: props.center,
        //         pov: {
        //           heading: isNaN(Number(props.heading))
        //             ? 0
        //             : Number(props.heading),
        //           pitch: 0,
        //         },
        //       }
        //     : props.displayPath &&
        //       streetViewMarker.open && {
        //         position: streetViewMarker.pos,
        //         pov: {
        //           heading: streetViewMarker.heading,
        //           pitch: 0,
        //         },
        //       }
        // }
        
      >
        {(props.markers || []).map((markerData, index) => {
          return (            
            <Marker
              // ref={(e) => {if (e) markers[index] = e.marker}}
              key={index}
              id={index}
              position={markerData.position}
              userRight={props.userRight}
              icon={markerData.icon}
              fitter={markerData.type === "fitter"}
              infoContent={markerData.infoContent}
              count={index + 1}
              totalMarkers={props.markers.length}
              streetView={
                (!props.displayPath && props.streetViewClick) ||
                (props.displayPath && streetViewMarker.open)
              }
              {...markerData.open} //{popup: true or false,count: 1 either used to track number of opens or index of popup};
              // markers={props.markers}
              markerReg={markerData.reg}
              // currentReg={props.currentReg}
              title={markerData.title}
              displayPath={props.displayPath}
              onMarkerStreetViewClick={handleMarkerStreetViewClick}
              onImageView={props.handleImageView}
              liveView={mapLiveView}
              />
          );
        })}
        {props.poi &&
          props.poi.map((poiData, index) => {
            return (
              <PoiCompMem
                key={index}
                position={poiData.position}
                poiName={poiData.poi_name}
                shape={poiData.poi_shape}
                color={poiData.poi_colour}
                strokeOpacity={0.8}
                fillOpacity={0.35}
                strokeWeight={1}
                diameter={poiData.poi_diameter}
                // mapZoom={mapZoom}
              />
            );
          })}

        {props.geo &&
          props.geo.map((geoData, index) => {
            return (
              <GeoCodes
                key={index}
                coords={geoData.Coordinates}
                color={
                  geoData.Type === "1"
                    ? "red"
                    : geoData.Type === "5"
                    ? "#2d2d2d"
                    : "#999999"
                }
              />
            );
          })}
      </MaptMem>
      </Wrapper>
    // </AuthContext.Provider>
  );
}

function clearOverlays(markersArray) {
  if (markersArray != null) {
    for (var i = 0; i < markersArray.length; i++) {
      if (markersArray[i]) {
        markersArray[i].setMap(null);
      }
    }
  }
  return [];
}
function clearArray(A) {
  if (A != null) {
    while (A.length > 0) {
      A.pop();
    }
  }
}

var sv;
var searchResultInfoWindow;
var searchPathList = [];
var searchPathPolylineList = [];
var tripPath = null;

// ── Haversine fallback for distance when geometry library isn't available ───
function haversineMetre(a, b) {
  const R = 6371000, rad = Math.PI / 180;
  const dLat = (b.lat - a.lat) * rad;
  const dLng = (b.lng - a.lng) * rad;
  const h = Math.sin(dLat / 2) ** 2 +
            Math.cos(a.lat * rad) * Math.cos(b.lat * rad) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
}

// ─── Marker icon helpers ──────────────────────────────────────────────────────

// Return a copy of a PNG marker icon with scaledSize/anchor scaled by the user's
// "Map Icon Size" setting. Only touches data:image/png markers; SVG and static
// icons are left alone. calcIcon already sizes every vehicle correctly (the car
// is a square top-down canvas for both ignition states, same as the other
// types), so this just multiplies uniformly and never changes the aspect ratio —
// scaling width and height by different factors is what used to stretch the car.
function scaleIconForZoom(icon, isDriving, zoom) {
  if (!icon || !icon.url || !icon.url.startsWith("data:image/png")) return icon;
  if (!icon.scaledSize) return icon;
  const s = icon._scale || 1; // "Map Icon Size" setting (1 / 1.2 / 1.5 / 2)
  const w = Math.max(4, Math.round(icon.scaledSize.width  * s));
  const h = Math.max(4, Math.round(icon.scaledSize.height * s));
  return {
    ...icon,
    scaledSize: window.google && new window.google.maps.Size(w, h),
    anchor:     window.google && new window.google.maps.Point(Math.round(w / 2), Math.round(h / 2)),
  };
}

// Mercator tile-pixel coordinates at a given zoom (matches screen px distance).
function _mercXY(lat, lng, zoom) {
  const scale  = Math.pow(2, zoom) * 256;
  const x      = (lng + 180) / 360 * scale;
  const latRad = lat * Math.PI / 180;
  const y      = (1 - Math.log(Math.tan(latRad) + 1 / Math.cos(latRad)) / Math.PI) / 2 * scale;
  return { x, y };
}

// Distance threshold in metres per zoom level. Returns 0 at zoom 16+ (no clustering).
function getClusterThreshold(zoomLevel) {
  if (zoomLevel <= 4)  return 105000;
  if (zoomLevel <= 5)  return 50000;
  if (zoomLevel <= 6)  return 30000;
  if (zoomLevel <= 7)  return 10000;
  if (zoomLevel <= 8)  return 7000;
  if (zoomLevel <= 9)  return 6000;
  if (zoomLevel <= 10) return 3000;
  if (zoomLevel <= 11) return 900;
  if (zoomLevel <= 12) return 500;
  if (zoomLevel <= 13) return 300;
  if (zoomLevel <= 14) return 200;
  if (zoomLevel <= 15) return 5;
  return 0;
}

// Group vehicle markers by proximity. Returns { singleRegs: Set, clusterGroups: [] }.
// Fitters and beacons are always singles (their icons aren't data:image/png).
function computeMarkerClusters(markers, zoom) {
  if (!markers?.length) return { singleRegs: new Set(), clusterGroups: [] };
  const threshold = getClusterThreshold(zoom);
  if (threshold === 0) return { singleRegs: null, clusterGroups: [] }; // zoom 16+: show all individually
  const used = new Array(markers.length).fill(false);
  const singleRegs   = new Set();
  const clusterGroups = [];

  for (let i = 0; i < markers.length; i++) {
    if (used[i]) continue;
    used[i] = true;
    const group = [i];
    for (let j = i + 1; j < markers.length; j++) {
      if (used[j]) continue;
      if (haversineMetre(markers[i].position, markers[j].position) < threshold) {
        group.push(j);
        used[j] = true;
      }
    }
    if (group.length === 1) {
      singleRegs.add(markers[i].reg);
    } else {
      const gm       = group.map(idx => markers[idx]);
      const lat      = gm.reduce((s, m) => s + m.position.lat, 0) / gm.length;
      const lng      = gm.reduce((s, m) => s + m.position.lng, 0) / gm.length;
      const stale    = gm.filter(m => m.infoContent?.invalidDate).length;
      const ignOn    = gm.filter(m => m.ignOn && !m.infoContent?.invalidDate).length;
      const color    = stale  > gm.length / 2 ? "#888888"
                     : ignOn >= gm.length / 2 ? "#18ba2b"
                     :                          "#e53935";
      clusterGroups.push({ position: { lat, lng }, count: gm.length, color });
    }
  }
  return { singleRegs, clusterGroups };
}

// SVG circle with count label, used for cluster markers.
function clusterCircleSvg(count, color, size = 36) {
  const fs = count > 99 ? 11 : count > 9 ? 13 : 15;
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}"><circle cx="${size/2}" cy="${size/2}" r="${size/2 - 2}" fill="${color}" stroke="white" stroke-width="2.5"/><text x="${size/2}" y="${size/2}" text-anchor="middle" dominant-baseline="central" fill="white" font-family="Arial,Helvetica,sans-serif" font-size="${fs}" font-weight="bold">${count}</text></svg>`;
}
// ─────────────────────────────────────────────────────────────────────────────

// ── Replay constants ─────────────────────────────────────────────────────────
const REPLAY_SPEEDS    = [1, 2, 3, 5];   // speed multipliers cycled by fast-forward
const REPLAY_MS_PER_PT = 120;            // base ms per path point at 1× (~2 min for 1 000 pts)

function bearingBetween(p1, p2) {
  const toRad = d => d * Math.PI / 180;
  const lat1 = toRad(p1.lat), lat2 = toRad(p2.lat);
  const dLng  = toRad(p2.lng - p1.lng);
  const y = Math.sin(dLng) * Math.cos(lat2);
  const x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLng);
  return (Math.atan2(y, x) * 180 / Math.PI + 360) % 360;
}

const replayBtnSx = {
  bgcolor: "#fff", color: "#333",
  border: "1px solid #ddd", borderRadius: "6px",
  width: 34, height: 34,
  "&:hover": { bgcolor: "#f0f0f0" },
};

const Mapt = ({
  // onClick,
  // panoramaInfo,
  panoramaClick,
  // onZoomChanged,
  // onIdle,
  panoramaPosition,
  panoramaHeading,
  searchPath,
  // searchPathTitle,
  street,
  suburb,
  displaySearchPath,
  hasCenter,
  onStreetViewChanged,
  onPoiClick,
  onDrawingModeChange,
  markers,
  poi,
  displayPath,
  darkMode,
  poiFitPath,
  children,
  style,
  ...options
}) => {
  const ref = React.useRef(null);
  const [map, setMap] = React.useState();
  const [panorama, setPanorama] = React.useState();
  const panRafRef    = React.useRef(null); // requestAnimationFrame id for smooth pan
  const prevRegRef   = React.useRef(null); // last vehicle reg — detects vehicle switches
  const prevCenterRef = React.useRef(null); // last panned-to { lat, lng } — skip if unchanged
  const [currZoom, setCurrZoom] = React.useState(options.zoom);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState({ open: false });

  // ── History route polyline ref ────────────────────────────────────────────────
  const historyPolylineRef = React.useRef(null);

  // ── Replay state & refs ───────────────────────────────────────────────────────
  const [replayActive, setReplayActive] = React.useState(false);
  const [replayPaused, setReplayPaused] = React.useState(false);
  const [speedIdx,     setSpeedIdx]     = React.useState(0);
  const [replayDateTime, setReplayDateTime] = React.useState(null);
  const replayMarkerRef     = React.useRef(null);
  const replayRafRef        = React.useRef(null);
  const replayAnimFnRef     = React.useRef(null);
  const replayPosRef        = React.useRef(0);
  const replayLastTRef      = React.useRef(null);
  const speedIdxRef         = React.useRef(0);
  const historyPathRef      = React.useRef(null);
  const historyTimesRef     = React.useRef(null);
  const replayCarModelRef   = React.useRef(null);

  // ── Logistics route overlay refs ─────────────────────────────────────────────
  const logisticsPolylinesRef   = React.useRef([]);
  const logisticsPoiOverlaysRef = React.useRef([]);

  // ── Clustering ───────────────────────────────────────────────────────────────
  const clusterOverlaysRef = React.useRef([]);

  // ── Preserve user zoom/position on data refresh ───────────────────────────
  // mapFittedRef: true after the first fitBounds in all-vehicles mode.
  // prevConstrainedRef: was the map in single-vehicle or trip-path mode last render?
  const mapFittedRef      = React.useRef(false);
  const prevConstrainedRef = React.useRef(!!(hasCenter || displayPath));

  // Only cluster when showing all vehicles (no single-vehicle focus, no trip path)
  const { singleRegs, clusterGroups } = React.useMemo(() => {
    if (displayPath || options.currentReg || !markers?.length) {
      return { singleRegs: null, clusterGroups: [] };
    }
    return computeMarkerClusters(markers, currZoom || 10);
  }, [markers, currZoom, displayPath, options.currentReg]); // eslint-disable-line

  // Sync imperative cluster-circle markers with the Google Maps instance
  React.useEffect(() => {
    if (!map || !window.google) return;
    clusterOverlaysRef.current.forEach(m => m.setMap(null));
    clusterOverlaysRef.current = [];
    clusterGroups.forEach(cluster => {
      const m = new window.google.maps.Marker({
        position: cluster.position,
        map,
        icon: {
          url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(clusterCircleSvg(cluster.count, cluster.color))}`,
          scaledSize: new window.google.maps.Size(36, 36),
          anchor:     new window.google.maps.Point(18, 18),
        },
        title: `${cluster.count} vehicles`,
        zIndex: 999,
      });
      m.addListener("click", () => {
        map.setZoom(Math.min((currZoom || 10) + 2, 18));
        map.setCenter(cluster.position);
      });
      clusterOverlaysRef.current.push(m);
    });
  }, [clusterGroups, map]); // eslint-disable-line

  React.useEffect(() => () => {
    clusterOverlaysRef.current.forEach(m => m.setMap(null));
  }, []);
  // ────────────────────────────────────────────────────────────────────────────

  const hideError = useCallback(() => {
    setOpenErrorSnackbar({ open: false });
  }, []);

  // ── Map tool state ───────────────────────────────────────────────────────────
  const [mapTool,             setMapTool]             = React.useState("none"); // "none" | "measure" | "polygon"
  const [hideMarkersWhileDraw, setHideMarkersWhileDraw] = React.useState(false);
  const [measureLines, setMeasureLines] = React.useState([]);     // [{polyline, iw}]
  const [drawCount,    setDrawCount]    = React.useState(0);      // points in current drawing
  const [pendingPoly,  setPendingPoly]  = React.useState(null);
  const [poiDialog,    setPoiDialog]    = React.useState(false);
  const [poiName,      setPoiName]      = React.useState("");
  const [localPois,    setLocalPois]    = React.useState(() => {
    try { return JSON.parse(localStorage.getItem("altrack_local_pois") || "[]"); }
    catch { return []; }
  });
  const [deletingPoi,  setDeletingPoi]  = React.useState(null); // POI object pending deletion
  const livePolylineRef   = React.useRef(null);              // measure: current in-progress polyline
  const livePolygonRef    = React.useRef(null);              // polygon: current in-progress polygon
  const drawPointsRef     = React.useRef([]);                // points accumulated since last finish
  const lastClickRef      = React.useRef({ time: 0, lat: 0, lng: 0 }); // for manual dbl-click detect
  const localPoiLayersRef = React.useRef([]);
  const isSavingPoiRef    = React.useRef(false);             // guard against double-submit (Enter + button click)
  const axiosPrivate      = useAxiosPrivate();

  // Reload POIs from localStorage when poi.js saves changes (color, name, delete)
  React.useEffect(() => {
    const handler = () => {
      try { setLocalPois(JSON.parse(localStorage.getItem("altrack_local_pois") || "[]")); }
      catch {}
    };
    window.addEventListener("altrack-pois-changed", handler);
    return () => window.removeEventListener("altrack-pois-changed", handler);
  }, []);

  // ── Street search state ──────────────────────────────────────────────────────
  const [streetSearchOpen,       setStreetSearchOpen]       = React.useState(false);
  const [streetSearchQuery,      setStreetSearchQuery]      = React.useState("");
  const [streetSearchSuburb,     setStreetSearchSuburb]     = React.useState("");
  const [streetSearchCity,       setStreetSearchCity]       = React.useState("");
  const [streetSearchHouseNo,    setStreetSearchHouseNo]    = React.useState("");
  const [streetSearchResults,    setStreetSearchResults]    = React.useState([]);
  const [streetSearchLoading,    setStreetSearchLoading]    = React.useState(false);
  const [streetSearchHasSearched,setStreetSearchHasSearched]= React.useState(false);
  const streetHighlightRef = React.useRef([]);

  /**
   * Smoothly pan the map to a target { lat, lng }.
   * Duration is read from localStorage key "altrack_pan_duration" (ms).
   * 0 = off (falls back to native panTo). Cancels any in-progress animation first.
   */
  const smoothPanTo = React.useCallback((targetLatLng) => {
    if (!map) return;

    const stored      = parseInt(localStorage.getItem("altrack_pan_duration") ?? "2000", 10);
    const durationMs  = isNaN(stored) ? 2000 : stored;

    if (panRafRef.current) { cancelAnimationFrame(panRafRef.current); panRafRef.current = null; }

    if (durationMs === 0) {
      map.panTo(targetLatLng);   // user chose "Off" — use Google's native pan
      return;
    }

    const startCenter = map.getCenter();
    const startLat = startCenter.lat();
    const startLng = startCenter.lng();
    const endLat   = typeof targetLatLng.lat === "function" ? targetLatLng.lat() : targetLatLng.lat;
    const endLng   = typeof targetLatLng.lng === "function" ? targetLatLng.lng() : targetLatLng.lng;

    // ease-out cubic: fast start, smooth landing
    const easeOut = (t) => 1 - Math.pow(1 - t, 3);

    const t0 = performance.now();
    const step = (now) => {
      const raw = Math.min((now - t0) / durationMs, 1);
      const e   = easeOut(raw);
      map.setCenter({ lat: startLat + (endLat - startLat) * e, lng: startLng + (endLng - startLng) * e });
      if (raw < 1) panRafRef.current = requestAnimationFrame(step);
      else         panRafRef.current = null;
    };
    panRafRef.current = requestAnimationFrame(step);
  }, [map]);

  React.useEffect(() => {
    console.log("render mapT liveView",options.liveView);
  });

  React.useEffect(() => {
    //mapt
    tripPath = new window.google.maps.Polyline({
      path: [],
      strokeColor: "#000000",
      strokeOpacity: 1.0,
      strokeWeight: 2,
    });
    sv = new window.google.maps.StreetViewService();
    searchResultInfoWindow = new window.google.maps.InfoWindow();
  }, []);

  React.useEffect(() => {
    if (ref.current && !map) {
      setMap(
        new window.google.maps.Map(ref.current, {
          center: map_control.saCenter,
          streetViewControl: false,
        })
      );
    }
    if (ref.current && map) {
      setPanorama(map.getStreetView());
      window.google.maps.event.trigger(map, "resize");
    }
  }, [ref, map]);

  // ── Dark mode map styles ─────────────────────────────────────────────────────
  React.useEffect(() => {
    if (!map) return;
    map.setOptions({ styles: darkMode ? DARK_MAP_STYLES : [] });
  }, [map, darkMode]);

  // ── Fit map to a POI polygon path ────────────────────────────────────────────
  React.useEffect(() => {
    if (!map || !poiFitPath || poiFitPath.length === 0) return;
    const bounds = new window.google.maps.LatLngBounds();
    poiFitPath.forEach((pt) => bounds.extend(pt));
    map.fitBounds(bounds, 60); // 60 px padding so the polygon isn't edge-to-edge
  }, [map, poiFitPath]);

  useDeepCompareEffectForMaps(() => {
    if (map) {
      if (!displayPath && hasCenter) {
        const newLat = typeof options.center.lat === "function" ? options.center.lat() : options.center.lat;
        const newLng = typeof options.center.lng === "function" ? options.center.lng() : options.center.lng;
        const centerChanged = !prevCenterRef.current ||
          prevCenterRef.current.lat !== newLat || prevCenterRef.current.lng !== newLng;

        if (centerChanged) {
          const sameVehicle  = options.currentReg && options.currentReg === prevRegRef.current;
          const jumpTooFar   = prevCenterRef.current &&
            haversineMetre(prevCenterRef.current, { lat: newLat, lng: newLng }) > 3000;
          if (sameVehicle && !jumpTooFar) {
            smoothPanTo(options.center);   // live position update — glide smoothly
          } else {
            if (panRafRef.current) { cancelAnimationFrame(panRafRef.current); panRafRef.current = null; }
            map.panTo(options.center);     // vehicle switch or big jump — standard snap pan
          }
          prevCenterRef.current = { lat: newLat, lng: newLng };
          prevRegRef.current    = options.currentReg;
        }
      }
      map.setOptions({
        maxZoom: options.maxZoom,
        minZoom: options.minZoom,
        zoom: options.zoom,
      });
    }
  }, [map, options]);

  React.useEffect(() => {
    let markersPosT = [];
    if (markers) {
      let bounds = new window.google.maps.LatLngBounds();
      let pos;
      markersPosT = markers.map((markerData) => {
        pos = {
          lat: markerData.position && markerData.position.lat,
          lng: markerData.position && markerData.position.lng,
        };
        bounds.extend(pos);
        return pos;
      });

      if (
        tripPath &&
        displayPath === true &&
        map &&
        displaySearchPath !== true &&
        !options.historyPath
      ) {
        tripPath.setPath(markersPosT);
      }
      if (
        map &&
        ((searchPath && searchPath.length === 0) || displaySearchPath !== true)
      ) {
        if (!hasCenter || displayPath) {
          // Detect transition back to free-browse (deselect vehicle or exit trip)
          const isConstrained = !!(hasCenter || displayPath);
          if (prevConstrainedRef.current && !isConstrained) {
            mapFittedRef.current = false; // returning to all-vehicles — allow one re-fit
          }
          prevConstrainedRef.current = isConstrained;

          // Only fitBounds on first load / returning from constrained mode.
          // Skip on periodic data refreshes so the user's zoom/position is preserved.
          if (displayPath || !mapFittedRef.current) {
            map.fitBounds(bounds);
            if (!displayPath) mapFittedRef.current = true;
          }
          // map.panToBounds(bounds);
        }
        if (!displayPath) {
          if (hasCenter) {
            const newLat = typeof options.center.lat === "function" ? options.center.lat() : options.center.lat;
            const newLng = typeof options.center.lng === "function" ? options.center.lng() : options.center.lng;
            const centerChanged = !prevCenterRef.current ||
              prevCenterRef.current.lat !== newLat || prevCenterRef.current.lng !== newLng;

            if (centerChanged) {
              const sameVehicle = options.currentReg && options.currentReg === prevRegRef.current;
              const jumpTooFar  = prevCenterRef.current &&
                haversineMetre(prevCenterRef.current, { lat: newLat, lng: newLng }) > 3000;
              if (sameVehicle && !jumpTooFar) {
                smoothPanTo(options.center);   // live position update — glide smoothly
              } else {
                if (panRafRef.current) { cancelAnimationFrame(panRafRef.current); panRafRef.current = null; }
                map.panTo(options.center);     // vehicle switch or big jump — standard snap pan
              }
              prevCenterRef.current = { lat: newLat, lng: newLng };
              prevRegRef.current    = options.currentReg;
            }
          } else if (markers.length < 1) {
            map.panTo(map_control.saCenter);           // reset — no animation needed
            map.fitBounds(map_control.saBounds);
          }
        }

        if (markers.length === 1) {
          map.setZoom(map_control.streetZoom);
        }
      }

      if (tripPath) {
        if (displayPath === true && map && !options.historyPath) {
          tripPath.setOptions({
            strokeColor: "#000000",
            strokeOpacity: 1.0,
            strokeWeight: 2,
          });
          tripPath.setMap(map);
        } else {
          tripPath.setMap(null);
        }
      }
    }
  }, [markers, options.center, displaySearchPath]); //displayPath, hasCenter, map, searchPath

  React.useEffect(() => {
    if (panorama) {
      console.log("MapT changed panorama,panoramaClick", panorama, panoramaClick);
      if (panoramaClick === true) {
        if (panoramaPosition && sv) {
          sv.getPanorama({
            location: panoramaPosition,
            radius: 50,
            source: "outdoor",
          })
            .then(function ({ data }) {
              const location = data.location;
              panorama.setPano(location.pano);
              panorama.setPov({ heading: panoramaHeading, pitch: 0 });
              panorama.setVisible(true);
            })
            .catch(function (err) {
              console.log("bad panorama request", err.code);
              onStreetViewChanged(panorama);
              setOpenErrorSnackbar({
                open: true,
                message:
                  "Could not find street view for the requested location",
              });
              //ZERO_RESULTS
            });
        } else {
          console.log("no panorama info provided!");
          onStreetViewChanged(panorama);
          setOpenErrorSnackbar({
            open: true,
            message: "No posiotion info provided!",
          });
        }
      } else {
        panorama.setVisible(false);
      }
    } else {
      console.log("MapT no panorama,panoramaClick", panorama,panoramaClick);
    }
  }, [panoramaClick, panorama, onStreetViewChanged, panoramaHeading, panoramaPosition]);

  // ── Logistics planned route polylines (dashed blue) ───────────────────────
  React.useEffect(() => {
    console.log("[Logistics] mapWrapper routes effect", options.logisticsRoutes);
    logisticsPolylinesRef.current.forEach(pl => pl.setMap(null));
    logisticsPolylinesRef.current = [];
    if (!map || !options.logisticsRoutes?.length) return;
    const dashSymbol = { path: "M 0,-1 0,1", strokeOpacity: 1, scale: 3 };
    options.logisticsRoutes.forEach(path => {
      if (!path?.length) return;
      const pl = new window.google.maps.Polyline({
        path,
        strokeColor:   "#1976D2",
        strokeOpacity: 0,
        strokeWeight:  3,
        icons: [{ icon: dashSymbol, offset: "0", repeat: "16px" }],
      });
      pl.setMap(map);
      logisticsPolylinesRef.current.push(pl);
    });
  }, [map, options.logisticsRoutes]); // eslint-disable-line

  // ── Logistics POI polygon fills (light blue shade) ────────────────────────
  React.useEffect(() => {
    logisticsPoiOverlaysRef.current.forEach(p => p.setMap(null));
    logisticsPoiOverlaysRef.current = [];
    if (!map || !options.logisticsPoiPolygons?.length) return;
    options.logisticsPoiPolygons.forEach(paths => {
      if (!paths?.length) return;
      const poly = new window.google.maps.Polygon({
        paths,
        fillColor:   "#1976D2",
        fillOpacity: 0.12,
        strokeWeight: 0,
        clickable:   false,
      });
      poly.setMap(map);
      logisticsPoiOverlaysRef.current.push(poly);
    });
  }, [map, options.logisticsPoiPolygons]); // eslint-disable-line

  // A: Draw history route as a single Polyline instead of per-ping markers.
  // Also cancel any running replay when the path changes or history is closed.
  React.useEffect(() => {
    historyPathRef.current  = options.historyPath  || null;
    historyTimesRef.current = options.historyTimes || null;
    replayCarModelRef.current = options.replayCarMakeModel || null;

    // Cancel replay
    if (replayRafRef.current) { cancelAnimationFrame(replayRafRef.current); replayRafRef.current = null; }
    if (replayMarkerRef.current) { replayMarkerRef.current.setMap(null); replayMarkerRef.current = null; }
    replayPosRef.current = 0; replayLastTRef.current = null;
    speedIdxRef.current  = 0;
    setReplayActive(false); setReplayPaused(false); setSpeedIdx(0); setReplayDateTime(null);

    // Draw polyline
    if (historyPolylineRef.current) { historyPolylineRef.current.setMap(null); historyPolylineRef.current = null; }
    if (!map || !options.historyPath?.length) return;
    historyPolylineRef.current = new window.google.maps.Polyline({
      path: options.historyPath,
      strokeColor: "#1a237e",
      strokeOpacity: 0.8,
      strokeWeight: 3,
    });
    historyPolylineRef.current.setMap(map);
  }, [map, options.historyPath]); // eslint-disable-line

  // React.useEffect(() => {
  //   if (tripPath) {
  //     if (displayPath === true && map) {
  //       tripPath.setOptions({
  //         strokeColor: "#000000",
  //         strokeOpacity: 1.0,
  //         strokeWeight: 2,
  //       });
  //       tripPath.setMap(map);
  //     } else {
  //       tripPath.setMap(null);
  //     }
  //   }
  // }, [markers]); //displayPath

  React.useEffect(() => {
    if (searchPath && displayPath !== true) {
      //[searchPath, displaySearchPath]
      //not trip mode
      if (searchResultInfoWindow) {
        searchResultInfoWindow.close();

        const content = renderToString(
          <div>
            <div>Location Search Result</div>
            <div>{(street || "") + ", " + (suburb || "")}</div>
          </div>
        );

        searchResultInfoWindow.setContent(content);
      }
      // let searchPosT = [];
      if (searchPath && searchPath.length > 0 && displaySearchPath === true && map) {        
        clearOverlays(searchPathPolylineList);
        let bounds = new window.google.maps.LatLngBounds();
        let pos;

        searchPathList = searchPath.map((locationList) => {
          return locationList.map((locData) => {
            pos = {
              lat: locData.Latitude,
              lng: locData.Longitude,
            };
            bounds.extend(pos);
            return pos;
          });
        });
        console.log("searchPathList: ", searchPathList);
        if (searchPathList && searchPathList.length > 0) {
          searchPathPolylineList = searchPathList.map((item) => {
            console.log(item);
            return new window.google.maps.Polyline({
              path: item || [],
              strokeColor: "#000000",
              strokeOpacity: 1.0,
              strokeWeight: 2,
            });
          });
        }
        if (
          searchPathPolylineList &&
          searchPathPolylineList.length > 0 &&
          map
        ) {
          searchPathPolylineList.forEach((item) => {
            item.setMap(map);
            item.setOptions({
              strokeColor: "#ff0682",
              strokeOpacity: 0.6,
              strokeWeight: 5,
            });
          });

          map.fitBounds(bounds);
          if (
            searchPathList &&
            searchPathList.length > 0 &&
            searchPathList[0].length > 0 &&
            searchResultInfoWindow
          ) {
            searchResultInfoWindow.setPosition(searchPathList[0][0]);
            searchResultInfoWindow.open(map);
          }
          // createInfoWindow("test windoe data");

          searchPathPolylineList.forEach((path) => {
            if (path) {
              window.google.maps.event.clearListeners(path, "click");
              window.google.maps.event.addListener(
                path,
                "click",
                function (event) {
                  // infowindow.content = content;
                  if (searchResultInfoWindow) {
                    searchResultInfoWindow.setPosition(event.latLng);
                    searchResultInfoWindow.open(map);
                  }
                }
              );
            }
          });
        }
        //tripPath.setMap(map);
      } else {
        searchPathPolylineList = clearOverlays(searchPathPolylineList);
        clearArray(searchPathPolylineList);
        // tripPath.setMap(null);
      }
    }
  }, [searchPath, displaySearchPath, map, displayPath, street, suburb]);

  React.useEffect(() => {
    if (map) {
      ["idle"].forEach((eventName) => {
        if (window.google) {
          window.google.maps.event.clearListeners(map, eventName);
        }
      });

      map.addListener("idle", () => setCurrZoom(map.getZoom()));
    }
  }, [map]); //, onIdle,onZoomChanged, onClick,

  React.useEffect(() => {
    if (map && panorama) {
      ["visible_changed"].forEach((eventName) => {
        if (window.google) {
          window.google.maps.event.clearListeners(panorama, eventName);
        }
      });
      panorama.addListener("visible_changed", () => {
        // if (panorama.getVisible()) {
        //   markers &&
        //     markers.forEach((element) => {
        //       if (element.open) {
        //         element.open.popup = false;
        //       }
        //       console.log(element.open);
        //     });
        // }
        onStreetViewChanged(panorama);
      });
    }
  }, [panorama, onStreetViewChanged, map]);

  // ── Custom click-to-draw ─────────────────────────────────────────────────────
  React.useEffect(() => {
    if (!map) return;

    const cleanupDraw = () => {
      if (livePolylineRef.current) { livePolylineRef.current.setMap(null); livePolylineRef.current = null; }
      if (livePolygonRef.current)  { livePolygonRef.current.setMap(null);  livePolygonRef.current  = null; }
      drawPointsRef.current = [];
      lastClickRef.current  = { time: 0, cx: -9999, cy: -9999 };
      setDrawCount(0);
      map.setOptions({ draggableCursor: undefined, disableDoubleClickZoom: false, clickableIcons: true });
    };

    if (mapTool === "none") { cleanupDraw(); return; }

    // Disable Google's built-in POI/place click popups while drawing so they don't
    // intercept clicks intended to add polygon/polyline vertices.
    map.setOptions({ draggableCursor: "crosshair", disableDoubleClickZoom: true, clickableIcons: false });

    const clickL = map.addListener("click", (e) => {
      const now = Date.now();
      const lat = e.latLng.lat();
      const lng = e.latLng.lng();
      // Use screen pixels for comparison — far more reliable than lat/lng precision
      const cx  = e.domEvent?.clientX ?? 0;
      const cy  = e.domEvent?.clientY ?? 0;
      const last = lastClickRef.current;

      // Double-click: within 600 ms and within 20 px of the previous click
      const isDouble = (now - last.time) < 600 &&
        Math.abs(cx - last.cx) < 20 && Math.abs(cy - last.cy) < 20;

      if (isDouble) {
        // first click of pair already added the point — just finalise
        lastClickRef.current = { time: 0, cx: -9999, cy: -9999 };
        finishDrawRef.current?.();
        return;
      }

      lastClickRef.current = { time: now, cx, cy };
      const pts = [...drawPointsRef.current, { lat, lng }];
      drawPointsRef.current = pts;
      setDrawCount(pts.length);

      if (mapTool === "measure") {
        if (!livePolylineRef.current) {
          livePolylineRef.current = new window.google.maps.Polyline({
            strokeColor: "#00bcd4", strokeWeight: 3, strokeOpacity: 0.9, map,
          });
        }
        livePolylineRef.current.setPath(pts);
      } else {
        if (!livePolygonRef.current) {
          livePolygonRef.current = new window.google.maps.Polygon({
            strokeColor: "#00bcd4", strokeWeight: 2, strokeOpacity: 0.9,
            fillColor: "#00bcd4", fillOpacity: 0.2, map,
            clickable: false,
          });
        }
        livePolygonRef.current.setPath(pts);
      }
    });

    return () => {
      window.google.maps.event.removeListener(clickL);
      cleanupDraw();
    };
  }, [map, mapTool]); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Render local POIs ────────────────────────────────────────────────────────
  React.useEffect(() => {
    if (!map) return;
    // Tear down any previously rendered layers
    localPoiLayersRef.current.forEach(({ polygon, marker }) => {
      polygon.setMap(null);
      if (marker) marker.setMap(null);
    });
    localPoiLayersRef.current = [];

    const drawing = mapTool === "polygon";
    localPois.forEach((poiItem) => {
      const color = poiItem.color || "#00bcd4";
      const polygon = new window.google.maps.Polygon({
        paths: poiItem.path,
        strokeColor: color, strokeWeight: 2, strokeOpacity: 0.9,
        fillColor: color, fillOpacity: 0.15, map,
        clickable: !drawing,
        cursor: drawing ? "crosshair" : "pointer",
      });
      // Label at centroid
      const bounds = new window.google.maps.LatLngBounds();
      poiItem.path.forEach((pt) => bounds.extend(pt));
      const marker = new window.google.maps.Marker({
        position: bounds.getCenter(), map: drawing ? null : map,
        icon: {
          url: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUGFdjyHQt+g8ABFsCIF75EPIAAAAASUVORK5CYII=",
        },
        label: {
          text: poiItem.name, color: "#00838f",
          fontWeight: "700", fontSize: "12px",
          className: "altrack-poi-label",
        },
        title: poiItem.name,
      });
      // Click polygon or label → open delete dialog
      polygon.addListener("click", () => setDeletingPoi(poiItem));
      marker.addListener("click",  () => setDeletingPoi(poiItem));
      localPoiLayersRef.current.push({ polygon, marker });
    });

    return () => {
      localPoiLayersRef.current.forEach(({ polygon, marker }) => {
        polygon.setMap(null);
        if (marker) marker.setMap(null);
      });
    };
  }, [map, localPois]); // eslint-disable-line react-hooks/exhaustive-deps

  // Disable interactivity on existing POI overlays while in draw mode so clicks reach the map.
  // Markers are removed entirely (they force a pointer cursor regardless of clickable flag).
  React.useEffect(() => {
    if (!map) return;
    const drawing = mapTool === "polygon";
    localPoiLayersRef.current.forEach(({ polygon, marker }) => {
      if (drawing) {
        polygon.setOptions({ clickable: false, cursor: "crosshair" });
        if (marker) marker.setMap(null);
      } else {
        polygon.setOptions({ clickable: true, cursor: "pointer" });
        if (marker) marker.setMap(map);
      }
    });
  }, [mapTool, map]);

  // ── Finish-draw handler (called by button AND double-click detection) ────────
  const finishDrawRef = React.useRef(null); // stable ref so the click closure can call it

  const handleFinishDraw = React.useCallback(() => {
    const pts = drawPointsRef.current;
    drawPointsRef.current = [];
    setDrawCount(0);
    lastClickRef.current = { time: 0, cx: -9999, cy: -9999 };

    if (mapTool === "measure") {
      if (pts.length >= 2) {
        // Capture the polyline reference NOW — before nulling the ref.
        // setMeasureLines updater runs lazily during render; reading livePolylineRef.current
        // at that point would return null.
        const finishedLine = livePolylineRef.current;
        livePolylineRef.current = null;
        if (finishedLine) finishedLine.setPath(pts);
        const latLngs = pts.map(p => new window.google.maps.LatLng(p.lat, p.lng));
        let metres = 0;
        try { metres = window.google.maps.geometry.spherical.computeLength(latLngs); }
        catch { metres = pts.reduce((s, _, i) => i === 0 ? 0 : s + haversineMetre(pts[i-1], pts[i]), 0); }
        const label = metres >= 1000 ? `${(metres / 1000).toFixed(2)} km` : `${Math.round(metres)} m`;
        const midPt = latLngs[Math.floor(latLngs.length / 2)];
        const iw = new window.google.maps.InfoWindow({
          content: `<div style="font-size:12px;font-weight:700;color:#00838f;padding:2px 6px">${label}</div>`,
          position: midPt, disableAutoPan: true,
        });
        iw.open(map);
        setMeasureLines(prev => [...prev, { polyline: finishedLine, iw }]);
      } else {
        if (livePolylineRef.current) { livePolylineRef.current.setMap(null); livePolylineRef.current = null; }
      }
    } else {
      if (pts.length >= 3) {
        const finishedPoly = livePolygonRef.current;
        livePolygonRef.current = null;
        if (finishedPoly) finishedPoly.setPath(pts);
        setPendingPoly(finishedPoly);
        setPoiName("");
        setPoiDialog(true);
      } else {
        if (livePolygonRef.current) { livePolygonRef.current.setMap(null); livePolygonRef.current = null; }
      }
    }
  }, [map, mapTool]); // eslint-disable-line react-hooks/exhaustive-deps

  // Keep the ref in sync so the click-listener closure can call the latest version
  React.useEffect(() => { finishDrawRef.current = handleFinishDraw; }, [handleFinishDraw]);

  // ── Tool handlers ────────────────────────────────────────────────────────────
  const handleSavePoi = React.useCallback(() => {
    if (!pendingPoly || !poiName.trim()) return;
    // Guard against double-submit: Enter keydown + button onClick can both fire
    // in the same synchronous event batch before React re-renders.
    if (isSavingPoiRef.current) return;
    isSavingPoiRef.current = true;
    // Reset after current tick so future draws work normally
    setTimeout(() => { isSavingPoiRef.current = false; }, 0);

    const path = pendingPoly.getPath().getArray().map((ll) => ({ lat: ll.lat(), lng: ll.lng() }));
    if (path.length < 3) return; // need at least 3 points to form a valid polygon
    pendingPoly.setMap(null);
    setPendingPoly(null);

    // The client generates the UUID. The server stores it as the primary key.
    // ON CONFLICT (id) DO UPDATE makes re-POSTs of the same UUID a no-op.
    // synced:false is the client guard — poi.js only pushes unsynced entries,
    // so hitting the API again is rare and safe even when it does happen.
    const newId  = crypto.randomUUID();
    const newPoi = { id: newId, name: poiName.trim(), color: "#00bcd4", path, synced: false };
    setLocalPois((prev) => {
      const updated = [...prev, newPoi];
      localStorage.setItem("altrack_local_pois", JSON.stringify(updated));
      return updated;
    });
    setPoiDialog(false);
    setMapTool("none");

    // Persist to server with the client UUID; mark synced on success.
    // No ID swap needed — local id === server id.
    axiosPrivate.post("/WebPoi", {
      id:      newId,
      name:    newPoi.name,
      color:   newPoi.color,
      polygon: path.map(({ lat, lng }) => [lat, lng]),
    }).then(() => {
      setLocalPois((prev) => {
        const updated = prev.map((p) => p.id === newId ? { ...p, synced: true } : p);
        localStorage.setItem("altrack_local_pois", JSON.stringify(updated));
        return updated;
      });
    }).catch(() => {
      // POST failed — entry stays synced:false; poi.js sync will retry on next open.
      // If it retries before mapWrapper's next attempt, the DB upsert handles both safely.
    });

    // map click listener re-arms automatically since mapTool is still "polygon"
  }, [pendingPoly, poiName, axiosPrivate]);

  const handleCancelPoi = React.useCallback(() => {
    if (pendingPoly) { pendingPoly.setMap(null); setPendingPoly(null); }
    setPoiDialog(false);
    setMapTool("none");
  }, [pendingPoly]);

  const handleDeletePoi = React.useCallback(() => {
    if (!deletingPoi) return;
    const deletedId = deletingPoi.id;
    setLocalPois((prev) => {
      const updated = prev.filter((p) => p.id !== deletedId);
      localStorage.setItem("altrack_local_pois", JSON.stringify(updated));
      return updated;
    });
    setDeletingPoi(null);

    // Only call DELETE if the entry was already synced to the server.
    // (synced:false entries were never persisted, so there's nothing to delete.)
    const wasOnServer = deletingPoi?.synced === true;
    if (wasOnServer) {
      axiosPrivate.delete(`/WebPoi/${deletedId}`).catch(() => {
        // If delete fails, the next poi.js open will reconcile via server list
      });
    }
  }, [deletingPoi, axiosPrivate]);

  const clearMeasure = React.useCallback(() => {
    setMeasureLines((prev) => {
      prev.forEach(({ polyline, iw }) => { polyline.setMap(null); iw.close(); });
      return [];
    });
  }, []);

  const toggleTool = React.useCallback((tool) => {
    // If dialog is open and user switches tools, cancel the pending polygon
    if (poiDialog && pendingPoly) {
      pendingPoly.setMap(null);
      setPendingPoly(null);
      setPoiDialog(false);
    }
    setMapTool((prev) => (prev === tool ? "none" : tool));
  }, [poiDialog, pendingPoly]);

  // Notify parent when drawing mode changes so it can pause live data updates
  React.useEffect(() => {
    onDrawingModeChange?.(mapTool === "polygon");
  }, [mapTool, onDrawingModeChange]);

  React.useEffect(() => {
    if (mapTool !== "polygon") setHideMarkersWhileDraw(false);
  }, [mapTool]);

  // Clear highlights when panel is closed
  React.useEffect(() => {
    if (!streetSearchOpen) {
      streetHighlightRef.current.forEach(o => o.setMap(null));
      streetHighlightRef.current = [];
    }
  }, [streetSearchOpen]);

  // ── Street search handlers ───────────────────────────────────────────────────
  const handleStreetSearch = React.useCallback(async () => {
    if (!streetSearchQuery.trim()) return;
    setStreetSearchLoading(true);
    setStreetSearchHasSearched(false);
    setStreetSearchResults([]);
    streetHighlightRef.current.forEach(o => o.setMap(null));
    streetHighlightRef.current = [];
    try {
      const isFiltered = streetSearchHouseNo.trim() || streetSearchSuburb.trim() || streetSearchCity.trim();
      const params = { query: streetSearchQuery.trim(), maxResults: isFiltered ? 10 : 20 };
      if (streetSearchHouseNo.trim()) params.houseNumber = streetSearchHouseNo.trim();
      if (streetSearchSuburb.trim())  params.suburb      = streetSearchSuburb.trim();
      if (streetSearchCity.trim())    params.city        = streetSearchCity.trim();
      const resp = await axiosPrivate.get("/routing/Search", { params });
      setStreetSearchResults(resp.data || []);
    } catch {
      setStreetSearchResults([]);
    } finally {
      setStreetSearchLoading(false);
      setStreetSearchHasSearched(true);
    }
  }, [streetSearchQuery, streetSearchSuburb, streetSearchCity, streetSearchHouseNo, axiosPrivate]);

  const handleStreetResultClick = React.useCallback((result) => {
    const geo = result.Geometry || result.geometry;
    if (!map || !geo) return;
    streetHighlightRef.current.forEach(o => o.setMap(null));
    streetHighlightRef.current = [];

    const geoType = geo.type;

    if (geoType === "Point") {
      const [lng, lat] = geo.coordinates;
      map.setCenter({ lat, lng });
      map.setZoom(16);
    } else if (geoType === "Polygon") {
      const ring = geo.coordinates[0];
      const bounds = new window.google.maps.LatLngBounds();
      ring.forEach(([lng, lat]) => bounds.extend({ lat, lng }));
      map.fitBounds(bounds);
      const highlightPoly = new window.google.maps.Polygon({
        paths: ring.map(([lng, lat]) => ({ lat, lng })),
        strokeColor: "#00bcd4", strokeOpacity: 0.8, strokeWeight: 2,
        fillColor: "#00bcd4", fillOpacity: 0.15, map,
      });
      streetHighlightRef.current = [highlightPoly];
      setTimeout(() => { highlightPoly.setMap(null); streetHighlightRef.current = []; }, 3000);
    } else if (geoType === "LineString") {
      const coords = geo.coordinates;
      const bounds = new window.google.maps.LatLngBounds();
      coords.forEach(([lng, lat]) => bounds.extend({ lat, lng }));
      map.fitBounds(bounds);
      const highlightLine = new window.google.maps.Polyline({
        path: coords.map(([lng, lat]) => ({ lat, lng })),
        strokeColor: "#00bcd4", strokeOpacity: 0.8, strokeWeight: 3, map,
      });
      streetHighlightRef.current = [highlightLine];
      setTimeout(() => { highlightLine.setMap(null); streetHighlightRef.current = []; }, 3000);
    }
  }, [map]);

  // ── Replay control functions ──────────────────────────────────────────────────
  const startReplay = () => {
    const path = historyPathRef.current;
    if (!path?.length || !map) return;
    replayPosRef.current = 0;
    replayLastTRef.current = null;

    if (replayMarkerRef.current) replayMarkerRef.current.setMap(null);
    const p0   = path[0];
    const icon = calcIcon(false, undefined, 0, true, undefined, false, replayCarModelRef.current);
    replayMarkerRef.current = new window.google.maps.Marker({ position: p0, map, icon, zIndex: 1000 });

    const animate = (ts) => {
      if (!replayMarkerRef.current) return;
      const dt = replayLastTRef.current ? ts - replayLastTRef.current : 16;
      replayLastTRef.current = ts;
      const prevI  = Math.floor(replayPosRef.current);
      const speed  = REPLAY_SPEEDS[speedIdxRef.current];
      replayPosRef.current += dt / (REPLAY_MS_PER_PT / speed);
      const maxPos = path.length - 1;
      if (replayPosRef.current >= maxPos) {
        replayMarkerRef.current.setMap(null);
        replayMarkerRef.current = null;
        replayPosRef.current = 0;
        setReplayActive(false);
        setReplayPaused(false);
        return;
      }
      const i    = Math.floor(replayPosRef.current);
      const frac = replayPosRef.current - i;
      const p1   = path[i], p2 = path[i + 1];
      const lat  = p1.lat + (p2.lat - p1.lat) * frac;
      const lng  = p1.lng + (p2.lng - p1.lng) * frac;
      const hdg  = bearingBetween(p1, p2);
      const ic   = calcIcon(false, undefined, hdg, true, undefined, false, replayCarModelRef.current);
      replayMarkerRef.current.setPosition({ lat, lng });
      if (ic) replayMarkerRef.current.setIcon(ic);
      // Keep marker visible — pan (not zoom) if it moves outside the current viewport
      const bounds = map.getBounds();
      if (bounds && !bounds.contains({ lat, lng })) map.panTo({ lat, lng });
      // Update timestamp/speed display each time we cross into a new real data point
      if (i !== prevI) {
        const entry = historyTimesRef.current?.[i];
        if (entry?.dt || entry?.spd != null) setReplayDateTime(entry);
      }
      replayRafRef.current = requestAnimationFrame(animate);
    };

    replayAnimFnRef.current = animate;
    setReplayActive(true);
    setReplayPaused(false);
    replayRafRef.current = requestAnimationFrame(animate);
  };

  const pauseReplay = () => {
    if (replayRafRef.current) { cancelAnimationFrame(replayRafRef.current); replayRafRef.current = null; }
    replayLastTRef.current = null;
    setReplayPaused(true);
  };

  const resumeReplay = () => {
    replayLastTRef.current = null;
    setReplayPaused(false);
    if (replayAnimFnRef.current) replayRafRef.current = requestAnimationFrame(replayAnimFnRef.current);
  };

  const stopReplay = () => {
    if (replayRafRef.current) { cancelAnimationFrame(replayRafRef.current); replayRafRef.current = null; }
    if (replayMarkerRef.current) { replayMarkerRef.current.setMap(null); replayMarkerRef.current = null; }
    replayPosRef.current = 0; replayLastTRef.current = null;
    speedIdxRef.current  = 0;
    setReplayActive(false); setReplayPaused(false); setSpeedIdx(0); setReplayDateTime(null);
  };

  const toggleSpeed = () => {
    const next = (speedIdxRef.current + 1) % REPLAY_SPEEDS.length;
    speedIdxRef.current = next;
    setSpeedIdx(next);
  };

  return (
    <>
      {/* Map div wrapped in a relative container so the toolbar can overlay */}
      <div style={{ ...style, position: "relative" }}>
        <div ref={ref} style={{ width: "100%", height: "100%" }} />

        {/* ── Floating map toolbar ─────────────────────────────────────────────── */}
        <Box sx={{
          position: "absolute", top: 58, right: 10,
          display: "flex", flexDirection: "column", gap: "6px", zIndex: 10,
        }}>
          {/* Measure tool */}
          <Tooltip title={mapTool === "measure" ? "Stop measuring" : "Measure distance"} placement="left">
            <IconButton size="small" onClick={() => toggleTool("measure")} sx={{
              bgcolor: mapTool === "measure" ? "#00bcd4" : "#fff",
              color:   mapTool === "measure" ? "#fff"    : "#555",
              boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
              border: mapTool === "measure" ? "1px solid #00838f" : "1px solid #ddd",
              borderRadius: "6px", width: 34, height: 34,
              "&:hover": { bgcolor: mapTool === "measure" ? "#00838f" : "#f0f0f0" },
            }}>
              {/* Ruler icon */}
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <rect x="3" y="8" width="18" height="8" rx="1" />
                <line x1="7"  y1="12" x2="7"  y2="16" />
                <line x1="10" y1="12" x2="10" y2="14" />
                <line x1="13" y1="12" x2="13" y2="14" />
                <line x1="16" y1="12" x2="16" y2="16" />
              </svg>
            </IconButton>
          </Tooltip>

          {/* Polygon / POI draw tool */}
          <Tooltip title={mapTool === "polygon" ? "Stop drawing" : "Draw POI area"} placement="left">
            <IconButton size="small" onClick={() => toggleTool("polygon")} sx={{
              bgcolor: mapTool === "polygon" ? "#00bcd4" : "#fff",
              color:   mapTool === "polygon" ? "#fff"    : "#555",
              boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
              border: mapTool === "polygon" ? "1px solid #00838f" : "1px solid #ddd",
              borderRadius: "6px", width: 34, height: 34,
              "&:hover": { bgcolor: mapTool === "polygon" ? "#00838f" : "#f0f0f0" },
            }}>
              {/* Pentagon icon */}
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round">
                <polygon points="12,3 21,9.5 18,20 6,20 3,9.5" />
              </svg>
            </IconButton>
          </Tooltip>

          {/* Hide markers toggle — only shown while drawing a POI */}
          {mapTool === "polygon" && (
            <Tooltip title={hideMarkersWhileDraw ? "Show markers" : "Hide markers"} placement="left">
              <IconButton size="small" onClick={() => setHideMarkersWhileDraw(p => !p)} sx={{
                bgcolor: hideMarkersWhileDraw ? "#ff6f00" : "#fff",
                color:   hideMarkersWhileDraw ? "#fff"    : "#555",
                boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
                border: hideMarkersWhileDraw ? "1px solid #e65100" : "1px solid #ddd",
                borderRadius: "6px", width: 34, height: 34,
                "&:hover": { bgcolor: hideMarkersWhileDraw ? "#e65100" : "#f0f0f0" },
              }}>
                {hideMarkersWhileDraw ? (
                  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                    <line x1="1" y1="1" x2="23" y2="23" />
                  </svg>
                ) : (
                  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                )}
              </IconButton>
            </Tooltip>
          )}

          {/* Draw / View POI Area */}
          {onPoiClick && (
            <Tooltip title="View POI Area's" placement="left">
              <IconButton size="small" onClick={onPoiClick} sx={{
                bgcolor: "#fff", color: "#555",
                boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
                border: "1px solid #ddd",
                borderRadius: "6px", width: 34, height: 34,
                "&:hover": { bgcolor: "#f0f0f0" },
              }}>
                {/* Location pin icon */}
                <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                </svg>
              </IconButton>
            </Tooltip>
          )}

          {/* Street search tool */}
          <Tooltip title={streetSearchOpen ? "Close street search" : "Search street"} placement="left">
            <IconButton size="small" onClick={() => setStreetSearchOpen(p => !p)} sx={{
              bgcolor: streetSearchOpen ? "#00bcd4" : "#fff",
              color:   streetSearchOpen ? "#fff"    : "#555",
              boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
              border: streetSearchOpen ? "1px solid #00838f" : "1px solid #ddd",
              borderRadius: "6px", width: 34, height: 34,
              "&:hover": { bgcolor: streetSearchOpen ? "#00838f" : "#f0f0f0" },
            }}>
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <circle cx="11" cy="11" r="7" />
                <line x1="16.5" y1="16.5" x2="21" y2="21" />
              </svg>
            </IconButton>
          </Tooltip>

          {/* Finish button — visible while actively drawing with enough points */}
          {mapTool !== "none" && drawCount >= (mapTool === "measure" ? 2 : 3) && (
            <Tooltip title={mapTool === "measure" ? "Finish & show distance" : "Close & save polygon"} placement="left">
              <IconButton size="small" onClick={handleFinishDraw} sx={{
                bgcolor: "#00c853", color: "#fff",
                boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                border: "1px solid #00953a", borderRadius: "6px", width: 34, height: 34,
                "&:hover": { bgcolor: "#00953a" },
              }}>
                {/* Checkmark */}
                <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20,6 9,17 4,12" />
                </svg>
              </IconButton>
            </Tooltip>
          )}

          {/* Clear measurements — only visible when there are lines */}
          {measureLines.length > 0 && (
            <Tooltip title="Clear measurements" placement="left">
              <IconButton size="small" onClick={clearMeasure} sx={{
                bgcolor: "#fff", color: "#e53935",
                boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
                border: "1px solid #ddd", borderRadius: "6px", width: 34, height: 34,
                "&:hover": { bgcolor: "#fff3f3" },
              }}>
                <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                  <path d="M9 3v1H4v2h1v13a2 2 0 002 2h10a2 2 0 002-2V6h1V4h-5V3H9zm0 5h2v9H9V8zm4 0h2v9h-2V8z"/>
                </svg>
              </IconButton>
            </Tooltip>
          )}
        </Box>

        {/* ── Replay controls (history mode only) ─────────────────────────────── */}
        {displayPath && (
          <Box sx={{
            position: "absolute", bottom: 32, left: "50%", transform: "translateX(-50%)",
            display: "flex", alignItems: "center", gap: "6px", zIndex: 10,
            bgcolor: "rgba(255,255,255,0.95)", borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.25)", padding: "4px 8px",
          }}>
            {/* Play / Pause / Resume */}
            {!replayActive ? (
              <Tooltip title="Replay history" placement="top">
                <IconButton size="small" onClick={startReplay} sx={replayBtnSx}>
                  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                    <path d="M8 5v14l11-7z"/>
                  </svg>
                </IconButton>
              </Tooltip>
            ) : replayPaused ? (
              <Tooltip title="Resume" placement="top">
                <IconButton size="small" onClick={resumeReplay} sx={replayBtnSx}>
                  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                    <path d="M8 5v14l11-7z"/>
                  </svg>
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title="Pause" placement="top">
                <IconButton size="small" onClick={pauseReplay} sx={replayBtnSx}>
                  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                    <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
                  </svg>
                </IconButton>
              </Tooltip>
            )}

            {/* Fast-forward speed cycle — only while replay is active */}
            {replayActive && (
              <Tooltip title="Change speed" placement="top">
                <IconButton size="small" onClick={toggleSpeed} sx={{
                  ...replayBtnSx, width: "auto", px: "8px", gap: "3px", fontSize: "11px", fontWeight: "bold",
                }}>
                  <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
                    <path d="M4 18l8.5-6L4 6v12zm9-12v12l8.5-6L13 6z"/>
                  </svg>
                  {REPLAY_SPEEDS[speedIdx]}×
                </IconButton>
              </Tooltip>
            )}

            {/* Stop — only while replay is active */}
            {replayActive && (
              <Tooltip title="Stop replay" placement="top">
                <IconButton size="small" onClick={stopReplay} sx={{
                  ...replayBtnSx, color: "#e53935", border: "1px solid #ffcdd2",
                  "&:hover": { bgcolor: "#fff3f3" },
                }}>
                  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                    <path d="M6 6h12v12H6z"/>
                  </svg>
                </IconButton>
              </Tooltip>
            )}
          </Box>
        )}

        {/* Replay timestamp label — shown below controls while replay is active */}
        {displayPath && replayActive && replayDateTime && (
          <Box sx={{
            position: "absolute", bottom: 10, left: "50%", transform: "translateX(-50%)",
            zIndex: 10, pointerEvents: "none",
            bgcolor: "rgba(255,255,255,0.88)", borderRadius: "5px",
            boxShadow: "0 1px 4px rgba(0,0,0,0.2)", px: "10px", py: "2px",
          }}>
            <Typography sx={{ fontSize: "11px", fontWeight: 500, color: "#333", whiteSpace: "nowrap" }}>
              {replayDateTime?.dt}
              {replayDateTime?.spd != null && (
                <span style={{ marginLeft: 8, color: "#555" }}>{replayDateTime.spd} km/h</span>
              )}
            </Typography>
          </Box>
        )}

        {/* ── Street search panel ──────────────────────────────────────────────── */}
        {streetSearchOpen && (
          <Box sx={{
            position: "absolute", top: 58, right: 54, width: 270, zIndex: 10,
            bgcolor: "rgba(28,28,28,0.94)",
            border: "1px solid rgba(255,255,255,0.1)",
            borderRadius: "10px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.6)",
            p: 1.5, display: "flex", flexDirection: "column", gap: "8px",
          }}>
            <TextField
              size="small" placeholder="Street name…" fullWidth autoFocus
              value={streetSearchQuery}
              onChange={(e) => { setStreetSearchQuery(e.target.value); setStreetSearchHasSearched(false); setStreetSearchResults([]); }}
              onKeyDown={(e) => { if (e.key === "Enter") handleStreetSearch(); }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  color: "#e0e0e0", fontSize: "0.82rem",
                  "& fieldset": { borderColor: "rgba(255,255,255,0.18)" },
                  "&:hover fieldset": { borderColor: "rgba(255,255,255,0.35)" },
                  "&.Mui-focused fieldset": { borderColor: "#00bcd4" },
                },
                "& .MuiInputBase-input::placeholder": { color: "rgba(255,255,255,0.38)", opacity: 1 },
              }}
            />
            <Box sx={{ display: "flex", gap: "6px" }}>
              <TextField
                size="small" placeholder="Suburb"
                value={streetSearchSuburb}
                onChange={(e) => { setStreetSearchSuburb(e.target.value); setStreetSearchHasSearched(false); setStreetSearchResults([]); }}
                onKeyDown={(e) => { if (e.key === "Enter") handleStreetSearch(); }}
                sx={{
                  flex: 1,
                  "& .MuiOutlinedInput-root": {
                    color: "#e0e0e0", fontSize: "0.8rem",
                    "& fieldset": { borderColor: "rgba(255,255,255,0.18)" },
                    "&:hover fieldset": { borderColor: "rgba(255,255,255,0.35)" },
                    "&.Mui-focused fieldset": { borderColor: "#00bcd4" },
                  },
                  "& .MuiInputBase-input::placeholder": { color: "rgba(255,255,255,0.38)", opacity: 1 },
                }}
              />
              <TextField
                size="small" placeholder="City"
                value={streetSearchCity}
                onChange={(e) => { setStreetSearchCity(e.target.value); setStreetSearchHasSearched(false); setStreetSearchResults([]); }}
                onKeyDown={(e) => { if (e.key === "Enter") handleStreetSearch(); }}
                sx={{
                  flex: 1,
                  "& .MuiOutlinedInput-root": {
                    color: "#e0e0e0", fontSize: "0.8rem",
                    "& fieldset": { borderColor: "rgba(255,255,255,0.18)" },
                    "&:hover fieldset": { borderColor: "rgba(255,255,255,0.35)" },
                    "&.Mui-focused fieldset": { borderColor: "#00bcd4" },
                  },
                  "& .MuiInputBase-input::placeholder": { color: "rgba(255,255,255,0.38)", opacity: 1 },
                }}
              />
            </Box>
            <Box sx={{ display: "flex", gap: "6px" }}>
              <TextField
                size="small" placeholder="House No."
                value={streetSearchHouseNo}
                onChange={(e) => setStreetSearchHouseNo(e.target.value)}
                onKeyDown={(e) => { if (e.key === "Enter") handleStreetSearch(); }}
                sx={{
                  flexGrow: 1,
                  "& .MuiOutlinedInput-root": {
                    color: "#e0e0e0", fontSize: "0.8rem",
                    "& fieldset": { borderColor: "rgba(255,255,255,0.18)" },
                    "&:hover fieldset": { borderColor: "rgba(255,255,255,0.35)" },
                    "&.Mui-focused fieldset": { borderColor: "#00bcd4" },
                  },
                  "& .MuiInputBase-input::placeholder": { color: "rgba(255,255,255,0.38)", opacity: 1 },
                }}
              />
              <Button
                size="small" variant="contained"
                onClick={handleStreetSearch}
                disabled={streetSearchLoading || !streetSearchQuery.trim()}
                sx={{
                  bgcolor: "#00bcd4", "&:hover": { bgcolor: "#00838f" },
                  "&.Mui-disabled": { bgcolor: "rgba(0,188,212,0.3)", color: "rgba(255,255,255,0.4)" },
                  minWidth: 38, px: 0, borderRadius: "6px",
                }}
              >
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                  <circle cx="11" cy="11" r="7" />
                  <line x1="16.5" y1="16.5" x2="21" y2="21" />
                </svg>
              </Button>
            </Box>

            {streetSearchLoading && (
              <Typography sx={{ color: "rgba(255,255,255,0.45)", fontSize: "0.73rem", textAlign: "center", py: "2px" }}>
                Searching…
              </Typography>
            )}

            {!streetSearchLoading && streetSearchHasSearched && streetSearchResults.length === 0 && (
              <Typography sx={{ color: "rgba(255,255,255,0.35)", fontSize: "0.73rem", textAlign: "center", py: "2px" }}>
                No results found
              </Typography>
            )}

            {streetSearchResults.length > 0 && (
              <Box sx={{
                maxHeight: 260, overflowY: "auto",
                "&::-webkit-scrollbar": { width: "4px" },
                "&::-webkit-scrollbar-thumb": { bgcolor: "rgba(255,255,255,0.2)", borderRadius: "2px" },
              }}>
                {streetSearchResults.map((r, i) => (
                  <Box key={i} onClick={() => handleStreetResultClick(r)} sx={{
                    px: 1.5, py: "7px", borderRadius: "6px", cursor: "pointer",
                    "&:hover": { bgcolor: "rgba(0,188,212,0.18)" },
                    "&:not(:last-child)": { borderBottom: "1px solid rgba(255,255,255,0.06)" },
                  }}>
                    <Typography sx={{ color: "#e8e8e8", fontSize: "0.78rem", fontWeight: 600, lineHeight: 1.3 }}>
                      {r.Street || r.Suburb || r.City || "Unknown"}
                    </Typography>
                    {(r.Suburb || r.City || r.Province) && (
                      <Typography sx={{ color: "rgba(255,255,255,0.45)", fontSize: "0.68rem", lineHeight: 1.3 }}>
                        {[r.Suburb, r.City, r.Province].filter(Boolean).join(", ")}
                      </Typography>
                    )}
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        )}

        {/* ── Active-tool hint banner ───────────────────────────────────────────── */}
        {mapTool !== "none" && (
          <Box sx={{
            position: "absolute", bottom: 24, left: "50%",
            transform: "translateX(-50%)",
            bgcolor: "rgba(0,0,0,0.65)", color: "#fff",
            fontSize: "0.73rem", px: 2, py: "6px",
            borderRadius: "20px", pointerEvents: "none",
            zIndex: 10, whiteSpace: "nowrap",
          }}>
            {mapTool === "measure"
              ? `📏  Click to add points${drawCount >= 2 ? " · press ✓ to finish" : ""}`
              : `⬡   Click to add vertices${drawCount >= 3 ? " · press ✓ to close" : ` (${drawCount}/3 min)`}`}
          </Box>
        )}
      </div>

      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={openErrorSnackbar.open}
        autoHideDuration={5000}
        onClose={hideError}
      >
        <Alert variant="filled" severity="error" sx={{ width: "100%" }}>
          {openErrorSnackbar.message || null}
        </Alert>
      </Snackbar>

      {/* ── POI name dialog ───────────────────────────────────────────────────── */}
      <Dialog open={poiDialog} onClose={handleCancelPoi} maxWidth="xs" fullWidth
        PaperProps={{ sx: { borderRadius: "12px" } }}>
        <DialogTitle sx={{ fontSize: "0.95rem", fontWeight: 700, pb: 0.5 }}>
          Name this POI
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus fullWidth size="small" label="POI name"
            value={poiName}
            onChange={(e) => setPoiName(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); handleSavePoi(); } }}
            sx={{
              mt: 1,
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": { borderColor: "#00bcd4" },
              },
              "& label.Mui-focused": { color: "#00838f" },
            }}
          />
        </DialogContent>
        <DialogActions sx={{ px: 2.5, pb: 2 }}>
          <Button onClick={handleCancelPoi} size="small" sx={{ textTransform: "none" }}>
            Cancel
          </Button>
          <Button onClick={handleSavePoi} size="small" variant="contained"
            disabled={!poiName.trim()}
            sx={{ bgcolor: "#00bcd4", "&:hover": { bgcolor: "#00838f" }, textTransform: "none" }}>
            Save POI
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Delete POI dialog ────────────────────────────────────────────────── */}
      <Dialog open={!!deletingPoi} onClose={() => setDeletingPoi(null)} maxWidth="xs" fullWidth
        PaperProps={{ sx: { borderRadius: "12px" } }}>
        <DialogTitle sx={{ fontSize: "0.95rem", fontWeight: 700, pb: 0.5 }}>
          Delete POI
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ fontSize: "0.85rem", color: "#444" }}>
            Delete <strong>{deletingPoi?.name}</strong>? This cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 2.5, pb: 2 }}>
          <Button onClick={() => setDeletingPoi(null)} size="small" sx={{ textTransform: "none" }}>
            Cancel
          </Button>
          <Button onClick={handleDeletePoi} size="small" variant="contained"
            sx={{ bgcolor: "#e53935", "&:hover": { bgcolor: "#b71c1c" }, textTransform: "none" }}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          const isGeoCode  = child.type === GeoCodes || child.type?.type?.name === "GeoCodesComp";
          if (isGeoCode && mapTool === "polygon") return null;

          const isPoiComp  = child.type?.type?.name === "PoiComp";
          const isPngMarker = child.props.icon?.url?.startsWith("data:image/png");

          // Per-child icon scale + visibility only for PNG vehicle markers
          const markerOverrides = (!displayPath && isPngMarker) ? (() => {
            const isDriving = child.props.infoContent?.ignitionOn;
            let scaledIcon = scaleIconForZoom(child.props.icon, isDriving, currZoom || 10);

            if (mapTool === "polygon" && scaledIcon?.scaledSize) {
              const w = Math.max(4, Math.round(scaledIcon.scaledSize.width  * 0.5));
              const h = Math.max(4, Math.round(scaledIcon.scaledSize.height * 0.5));
              scaledIcon = {
                ...scaledIcon,
                scaledSize: new window.google.maps.Size(w, h),
                anchor:     new window.google.maps.Point(Math.round(w / 2), Math.round(h / 2)),
              };
            }

            // Focus mode: one vehicle selected — hide all others (keep fitters visible)
            // Cluster mode: hide markers that are part of a cluster group
            const isFitter = child.props.fitter;
            let visible;
            if (mapTool === "polygon" && hideMarkersWhileDraw) {
              visible = false;
            } else if (options.currentReg) {
              visible = isFitter || child.props.markerReg === options.currentReg;
            } else {
              visible = isFitter || singleRegs === null || singleRegs.has(child.props.markerReg);
            }
            return { icon: scaledIcon, visible };
          })() : {};

          return React.cloneElement(child, {
            map,
            ...(isPoiComp ? { mapzoom: currZoom } : {}),
            ...markerOverrides,
            ...(isPngMarker ? { drawingMode: mapTool === "polygon" } : {}),
          });
        }
      })}
    </>
  );
};

const MaptMem = React.memo(Mapt);
/*{
  mapZoom
}*/

const PoiComp = (options) => {
  const [poi, setPoi] = useState();
  const [titleMarker, setTitleMarker] = useState();
  // const { mapZoom } = useMapZoom();

  const getSquare = (latlng, diamKm) => {
    let sqbounds = { north: 0, south: 0, east: 0, west: 0 };
    if (latlng.lat.toString().indexOf("-") > -1) {
      sqbounds.north = (Math.abs(latlng.lat) - (0.01 * diamKm) / 2) * -1;
    } else {
      sqbounds.north = latlng.lat - (0.01 * diamKm) / 2;
    }

    if (latlng.lat.toString().indexOf("-") > -1) {
      sqbounds.south = (Math.abs(latlng.lat) + (0.01 * diamKm) / 2) * -1;
    } else {
      sqbounds.south = latlng.lat + (0.01 * diamKm) / 2;
    }

    if (latlng.lng.toString().indexOf("-") > -1) {
      sqbounds.west = (Math.abs(latlng.lng) - (0.01 * diamKm) / 2) * -1;
    } else {
      sqbounds.west = latlng.lng - (0.01 * diamKm) / 2;
    }
    if (latlng.lng.toString().indexOf("-") > -1) {
      sqbounds.east = (Math.abs(latlng.lng) + (0.01 * diamKm) / 2) * -1;
    } else {
      sqbounds.east = latlng.lng + (0.01 * diamKm) / 2;
    }
    return sqbounds;
  };

  React.useEffect(() => {
    if (!poi) {
      if (options.shape === "circle") {
        setPoi(
          new window.google.maps.Circle({
            strokeColor: options.color,
            strokeOpacity: options.strokeOpacity,
            strokeWeight: options.strokeWeight,
            fillColor: options.color,
            fillOpacity: options.fillOpacity,
            map: options.map,
            center: options.position,
            radius: options.diameter && (options.diameter / 2) * 1000,
          })
        );
      } else if (options.shape === "square") {
        setPoi(
          new window.google.maps.Rectangle({
            strokeColor: options.color,
            strokeOpacity: options.strokeOpacity,
            strokeWeight: options.strokeWeight,
            map: options.map,
            fillColor: options.color,
            fillOpacity: options.fillOpacity,
            bounds: getSquare(options.position, options.diameter),
          })
        );
      }

      setTitleMarker(
        new window.google.maps.Marker({
          icon: {
            url: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUGFdjyHQt+g8ABFsCIF75EPIAAAAASUVORK5CYII=",
          },
          visible: false,
          map: options.map,
          label: {
            text: options.poiName,
            color: options.color,
            className: "altrack-poi-label",
          },
          title: options.poiName,
          properties: {
            idx: 0,
            popup: "",
          },
        })
      );
    }
    if (titleMarker) {
      titleMarker.icon.labelOrigin = new window.google.maps.Point(50, 0);
    }
    // remove poi from map on unmount
    return () => {
      if (poi) {
        if (window.google) {
          poi.setMap(null);
          titleMarker.setMap(null);
        }
      }
    };
  }, [
    poi,
    titleMarker,
    options.color,
    options.diameter,
    options.fillOpacity,
    options.map,
    options.poiName,
    options.position,
    options.shape,
    options.strokeOpacity,
    options.strokeWeight,
  ]);

  React.useEffect(() => {
    if (poi && options) {
      if (options.shape === "circle") {
        poi.setOptions({
          strokeColor: options.color,
          strokeOpacity: options.strokeOpacity,
          strokeWeight: options.strokeWeight,
          map: options.map,
          fillColor: options.color,
          fillOpacity: options.fillOpacity,
          center: options.position,
          radius: options.diameter && (options.diameter / 2) * 1000,
        });
      } else if (options.shape === "square") {
        poi.setOptions({
          strokeColor: options.color,
          strokeOpacity: options.strokeOpacity,
          strokeWeight: options.strokeWeight,
          map: options.map,
          fillColor: options.color,
          fillOpacity: options.fillOpacity,
          bounds: getSquare(options.position, options.diameter),
        });
      }

      if (titleMarker) {
        titleMarker.setOptions({
          map: options.map,
          label: {
            text: options.poiName,
            color: options.color,
            className: "altrack-poi-label",
          },
          title: options.poiName,
        });

        if (options.shape === "circle") {
          titleMarker.setPosition(options.position);
        } else if (options.shape === "square") {
          titleMarker.setPosition({
            lat: JSON.parse(JSON.stringify(poi.getBounds())).north,
            lng: JSON.parse(JSON.stringify(poi.getBounds())).west,
          });
        }
      }
    }
  }, [poi, titleMarker, options]); //, onIdle,onZoomChanged, onClick,

  React.useEffect(() => {
    if (titleMarker && options.mapzoom) {
      if (options.mapzoom >= map_control.streetZoom - 2) {
        titleMarker.setVisible(true);
      } else {
        titleMarker.setVisible(false);
      }
    }
  }, [options.mapzoom, titleMarker]);
};
const PoiCompMem = React.memo(PoiComp);

function useDeepCompareEffectForMaps(callback, dependencies) {
  React.useEffect(callback, dependencies.map(useDeepCompareMemoize));
}

function useDeepCompareMemoize(value) {
  const ref = React.useRef();

  if (!deepCompareEqualsForMaps(value, ref.current)) {
    ref.current = value;
  }
  return ref.current;
}

const deepCompareEqualsForMaps = createCustomEqual((deepEqual) => (a, b) => {
  if (
    isLatLngLiteral(a) ||
    a instanceof window.google.maps.LatLng ||
    isLatLngLiteral(b) ||
    b instanceof window.google.maps.LatLng
  ) {
    return new window.google.maps.LatLng(a).equals(
      new window.google.maps.LatLng(b)
    );
  }
  // TODO extend to other types
  // use fast-equals for other objects
  return deepEqual(a, b);
});
class MapErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(err) {
    console.warn("[MapErrorBoundary] Map crashed:", err.message);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          height: "100%", display: "flex", alignItems: "center",
          justifyContent: "center", background: "#f5f5f5",
          color: "#aaa", fontSize: 13, flexDirection: "column", gap: 8,
        }}>
          <span style={{ fontSize: 32 }}>🗺️</span>
          <span>Map unavailable</span>
        </div>
      );
    }
    return this.props.children;
  }
}

const renderMapStatus = (status) => {
  if (status === Status.FAILURE) {
    return (
      <div style={{
        height: "100%", display: "flex", alignItems: "center",
        justifyContent: "center", background: "#f5f5f5",
        color: "#aaa", fontSize: 13, flexDirection: "column", gap: 8,
      }}>
        <span style={{ fontSize: 32 }}>🗺️</span>
        <span>Map unavailable</span>
      </div>
    );
  }
  return null;
};

const MapWrapperCompSafe = (props) => (
  <MapErrorBoundary>
    <MapWrapperComp {...props} />
  </MapErrorBoundary>
);

export default React.memo(MapWrapperCompSafe);
export { renderMapStatus };
